import type {
  CheckInChildRequest,
  ChildCheckInCreatedResponse,
  ChildCheckInResponse,
  GuardianResponse,
  PaginatedResponse,
} from '@tabita/contracts';
import { apiRequest } from './api-client';

export interface ListKidsCheckInsParams {
  readonly childPersonId?: string | undefined;
  readonly openOnly?: boolean | undefined;
  readonly limit?: number | undefined;
}

export const kidsApi = {
  list(params: ListKidsCheckInsParams = {}, signal?: AbortSignal) {
    return apiRequest<PaginatedResponse<ChildCheckInResponse>>('/kids/checkins', {
      query: { ...params },
      signal,
    });
  },

  checkIn(body: CheckInChildRequest) {
    return apiRequest<ChildCheckInCreatedResponse>('/kids/checkins', { method: 'POST', body });
  },

  checkOut(id: string, code: string, pickedUpByPersonId?: string | null) {
    return apiRequest<ChildCheckInResponse>(`/kids/checkins/${id}/checkout`, {
      method: 'POST',
      body: { code, pickedUpByPersonId },
    });
  },

  guardians(id: string, signal?: AbortSignal) {
    return apiRequest<readonly GuardianResponse[]>(`/kids/checkins/${id}/guardians`, { signal });
  },
};
